const getApiUrl = () => {
  const {
    NODE_ENV,
    REACT_APP_API_URL_PRODUCTION,
    REACT_APP_API_URL_DEVELOPMENT,
  } = process.env;

  if (NODE_ENV === 'production') {
    if (!REACT_APP_API_URL_PRODUCTION) {
      throw new Error(
        'La variable de entorno REACT_APP_API_URL_PRODUCTION no está definida'
      );
    }
    return REACT_APP_API_URL_PRODUCTION;
  } else {
    if (!REACT_APP_API_URL_DEVELOPMENT) {
      throw new Error(
        'La variable de entorno REACT_APP_API_URL_DEVELOPMENT no está definida'
      );
    }
    return REACT_APP_API_URL_DEVELOPMENT;
  }
};

const apiUrl = getApiUrl();
const {
  REACT_APP_EPAYCO_API_URL,
  REACT_APP_EPAYCO_PUBLIC_KEY,
  REACT_APP_EPAYCO_PRIVATE_KEY,
  REACT_APP_EPAYCO_P_KEY,
  REACT_APP_EPAYCO_MODE,
  REACT_APP_EPAYCO_REDIRECT_BASE_URL,
} = process.env;

if (
  !REACT_APP_EPAYCO_API_URL ||
  !REACT_APP_EPAYCO_PUBLIC_KEY ||
  !REACT_APP_EPAYCO_PRIVATE_KEY ||
  !REACT_APP_EPAYCO_P_KEY ||
  !REACT_APP_EPAYCO_MODE ||
  !REACT_APP_EPAYCO_REDIRECT_BASE_URL
) {
  throw new Error('Faltan variables de entorno críticas para Epayco');
}
const config = {
  apiUrl,
  epayco: {
    apiUrl: REACT_APP_EPAYCO_API_URL,
    publicKey: REACT_APP_EPAYCO_PUBLIC_KEY,
    privateKey: REACT_APP_EPAYCO_PRIVATE_KEY,
    pKey: REACT_APP_EPAYCO_P_KEY,
    mode: REACT_APP_EPAYCO_MODE,
    redirectBaseUrl: REACT_APP_EPAYCO_REDIRECT_BASE_URL,
  },
};

export default config;
